var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"expandable-container",class:{ 'is-expanded': _vm.isExpanded, 'can-expand': _vm.canExpand }},[_c('div',{ref:"textContent",staticClass:"content",on:{"click":_vm.toggle}},[_vm._t("default")],2),(_vm.canExpand)?_c('span',{staticClass:"arrow",on:{"click":_vm.toggle}},[_vm._v("▼")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }